<template>
    <el-dialog
        class="metafileds"
        :visible.sync="metafiledsVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="800px"
        title="metafileds"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="metafiledsForm"
                :model="metafiledsForm"
                :rules="rules"
                label-width="100px"
                v-if="is_combine"
            >
                <div v-for="(item,index) in metafiledsForm.combine_custom_properties" :key="item.index">
                    <el-row style="padding-bottom:10px">
                        <el-col :span="24">
                            SKU：{{item.sku}}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item
                                prop="custom_properties"
                                size="small"
                                label-width="0"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="item.custom"
                                    placeholder="Please input "
                                    type="textarea"
                                    autofocus
                                    :autosize="{ minRows: 6, maxRows: 8 }"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <el-form
                ref="metafiledsForm"
                :model="metafiledsForm"
                :rules="rules"
                label-width="100px"
                v-else
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            prop="custom_properties"
                            size="small"
                            label-width="0"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="metafiledsForm.custom_properties"
                                placeholder="Please input "
                                type="textarea"
                                autofocus
                                :autosize="{ minRows: 6, maxRows: 8 }"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="closeDialog">Close</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";

export default {
    data() {
        return {
            metafiledsForm: {
                custom_properties: "",
                combine_custom_properties: [],
                combine_custom_properties_new: []
            },
        };
    },
    methods: {
        closeDialog() {
            this.$refs["metafiledsForm"].clearValidate();
            this.$refs["metafiledsForm"].resetFields();
            this.$emit("update:metafiledsVisible", false);
        },
        save() {
           // console.log(this.metafiledsForm.combine_custom_properties);
           if(this.is_combine){
                this.metafiledsForm.combine_custom_properties_new = [];
                let new_prop =  this.metafiledsForm.combine_custom_properties;
                for(let x in new_prop){
                    let property = {"sku":new_prop[x].sku};
                    if(new_prop[x].hasOwnProperty("custom") && new_prop[x].custom.replace(/(^\s*)|(\s*$)/g, "") != ""){
                        let myArray = new_prop[x].custom.split("\n");
                        let cus = {};
                        for(var j in myArray){
                            if(myArray[j]){
                                var index = myArray[j].indexOf(":"); 
                                if(index == -1){
                                    this.$message.warning("Incorrect data format");
                                    return false;
                                }
                                var k = myArray[j].slice(0, index);
                                var v = myArray[j].slice(index+1);
                                cus[k] = v.replace(/(^\s*)|(\s*$)/g, "");
                            }
                        }
                        property["custom"]  = cus;  
                    }
                    this.metafiledsForm.combine_custom_properties_new.push(property);
                    //this.metafiledsForm.combine_custom_properties_new.push({"sku":new_prop[x].sku,"custom":new_prop[x].custom});
                }
           }
           //console.log(this.metafiledsForm);return false;
            this.$emit("saveMetafiled", this.metafiledsForm);
            this.closeDialog();
        },
    },
    props: {
        metafiledsVisible: Boolean,
        funcName: String,
        is_combine: Boolean,
        metafiledsLabel: [String, Object],
    },
    watch: {
        metafiledsVisible() {
            if (this.metafiledsVisible) {
                if (this.metafiledsLabel) {
                    //console.log(this.metafiledsLabel)
                    //this.metafiledsForm.custom_properties = this.is_combine == 2 ? this.metafiledsLabel : JSON.parse(this.metafiledsLabel);
                    if(!this.is_combine){
                        this.metafiledsForm.custom_properties = this.metafiledsLabel;
                    }else{
                        let custom_properties = JSON.parse(this.metafiledsLabel);
                        this.metafiledsForm.combine_custom_properties = [];
                        for(let x in  custom_properties){
                            let custom = "";
                            if(custom_properties[x].custom){
                                Object.entries(custom_properties[x].custom).forEach(
                                    (sItem) => {
                                        custom += `${sItem[0]}: ${typeof sItem[1] == 'string' ? sItem[1] : JSON.stringify(sItem[1])}\n`;
                                    }
                                );
                            }
                            
                            this.metafiledsForm.combine_custom_properties.push({"sku":custom_properties[x].sku,"custom":custom})
                        }
                    }
                }else{
                    this.metafiledsForm.custom_properties = "";
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.metafileds {
    .container {
    }
}
</style>
